import styled from "styled-components";
import { Layout } from "antd";
import { media } from "config/theme/constants";

export const LayoutMaster = styled(Layout)`
  height: 100vh;
  overflow: hidden;
`;

export const LayoutMain = styled(Layout)`
  @media only screen and ${media.md} {
    margin-left: 7rem;
  }

  @media only screen and ${media.xl} {
    margin-left: unset;
  }
`;
